import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { DiscountGroup } from "../../../../generated/generated-types";
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { DiscountGroupService } from "../../services/discount-group.service";

@Component({
  selector: 'app-discount-group-dropdown',
  templateUrl: './discount-group-dropdown.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class DiscountGroupDropdownComponent extends GenericBaseModelDropDown<DiscountGroup> {

  constructor(
    private service: DiscountGroupService
  ) {
    super(service, "DiscountGroup");
  }

}
